import { createEditor } from 'com/Editor';
import { apiAddUser, apiGetUser, apiUpdateUser } from 'core/api';
import { TUserUpdate } from 'shared/types/domain';

import Form from './Form';

const editor = createEditor<null, TUser, TUserUpdate>({
  mode: 'withoutContainer',
  transform,
  Form,
  getParentUid: () => '%fakeParentId%',
  onValidate: validate,
  genNewEntity: (): TUserUpdate => ({
    login: '',
    email: null,
    isAdmin: false,
  }),
  // oxlint-disable-next-line typescript-eslint/require-await
  apiGetContainer: async () => null,
  apiGetEntity: apiGetUser,
  apiUpdateEntity: apiUpdateUser,
  apiAddEntity: (_containerId, user) => apiAddUser(user),
});

function validate(user: TUserUpdate | TUser) {
  if (!user.login) {
    return { isEmpty: true, error: null };
  }

  // TODO: handle oldPassword and newPassword.

  return { isEmpty: false, error: null };
}

function transform(
  user: TUser | TUserUpdate,
  field: string,
  _subField: string | undefined,
  value: string
): TUserUpdate {
  if (field === 'isAdmin') {
    return { ...user, isAdmin: !user.isAdmin };
  }

  return { ...user, [field as keyof TUser]: value ? value : null };
}

export const UserEditorProvider = editor.EditorProvider;
export const useUserEditor = function useUserEditor() {
  const { createEntity, editEntity } = editor.useEditor();
  return {
    createUser: () => createEntity('%fakeParentId%'),
    editUser: editEntity,
  };
};
